import { render, staticRenderFns } from "./donationCertificate.vue?vue&type=template&id=8c00b09a&scoped=true&"
import script from "./donationCertificate.vue?vue&type=script&lang=js&"
export * from "./donationCertificate.vue?vue&type=script&lang=js&"
import style0 from "./donationCertificate.vue?vue&type=style&index=0&id=8c00b09a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c00b09a",
  null
  
)

export default component.exports